import { ClubsFormComponent } from './clubs-form/clubs-form.component';
import { NgModule } from '@angular/core';
import { ClubsComponent } from './clubs.component';
import { Routes, RouterModule } from '@angular/router';
import { ClubsDetailComponent } from './clubs-detail/clubs-detail.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:ClubsComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin"]}},
  {path:'detail',component:ClubsDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin"]}},
  {path:'new',component:ClubsFormComponent,canActivate:[RoleGuard],data:{roles: ["admin","user"]}},
  {path:'edit',component:ClubsFormComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin"]}},
]

// os utilizadores do clube não podem ver a sessão de clubes.
// o Administrador Faz CRUD
// o user do khuzela Lê e Actualiza somente

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class ClubsRoutingModule { }
